var v1="<div><div gnp-common-header=\"\"></div><div ng-transclude=\"\"></div><div gnp-common-footer=\"\"></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/common-wrapper/common-wrapper-b.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/common-wrapper/common-wrapper-b.jade
// module id = 107
// module chunks = 0